import * as React from "react"
import { TextFieldSeeker } from "@ui-seeker/core"

import { useAdminSkuForm } from "../../@hooks"


export default function AdminSkuFormEAN() {
    const { localValue, handleChange } = useAdminSkuForm("ean")

    return <TextFieldSeeker
        label="EAN"
        value={localValue || ""}
        onChange={e => handleChange(e.target.value)}
    />
}